import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  Cart,
  CartService,
  Order,
  OrderItem,
  OrdersService,
} from '@delroydsouza/orders';
import { UserService } from 'libs/users/src/lib/services/user.service';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'orders-checkout-page',
  templateUrl: './checkout-page.component.html',
  styles: [],
})
export class CheckoutPageComponent implements OnInit {
  checkoutFormGroup!: FormGroup;
  isSubmitted = false;
  orderItems: OrderItem[] = [];
  userId!: string;
  countries = [];
  endSub$: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private cartService: CartService,
    private ordersService: OrdersService
  ) {}

  ngOnInit(): void {
    this._initForm();
    this._autoFillUserData();
    this._getCartItems();
    this._getCountries();
  }

  _initForm() {
    this.checkoutFormGroup = this.formBuilder.group({
      street: ['', Validators.required],
      apartment: ['', Validators.required],
      zip: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
    });
  }

  private _getCountries() {
    this.countries = this.userService.getCountries();
  }

  private _autoFillUserData() {
    this.userService
      .observeCurrentUser()
      .pipe(takeUntil(this.endSub$))
      .subscribe((user) => {
        if (user) {
          this.userId = user.id;
          this.checkoutForm['name'].setValue(user.name);
          this.checkoutForm['email'].setValue(user.email);
          this.checkoutForm['phone'].setValue(user.phone);
          this.checkoutForm['city'].setValue(user.city);
          this.checkoutForm['country'].setValue(user.country);
          this.checkoutForm['zip'].setValue(user.zip),
            this.checkoutForm['apartment'].setValue(user.apartment);
          this.checkoutForm['street'].setValue(user.street);
        }
      });
  }

  placeOrder() {
    this.isSubmitted = true;
    if (this.checkoutFormGroup.invalid) {
      return;
    }

    const order: Order = {
      orderItems: this.orderItems,
      shippingAddress1: this.checkoutForm['street'].value,
      shippingAddress2: this.checkoutForm['apartment'].value,
      city: this.checkoutForm['city'].value,
      zip: this.checkoutForm['zip'].value,
      country: this.checkoutForm['country'].value,
      phone: this.checkoutForm['phone'].value,
      status: 0,
      user: this.userId,
      dateOrdered: `${Date.now()}`,
    };

    this.ordersService.cacheOrderData(order);

    this.ordersService
      .createCheckoutSession(this.orderItems)
      .subscribe((error) => {
        if (error) {
          console.log('Error in redirect to payment');
        }
      });
  }

  private _getCartItems() {
    const cart: Cart = this.cartService.getCart();
    this.orderItems = cart.items.map((item) => {
      return {
        product: item.productId,
        quantity: item.quantity,
      };
    });
  }

  get checkoutForm() {
    return this.checkoutFormGroup.controls;
  }

  backToCart() {
    this.router.navigate(['/cart']);
  }

  ngOnDestroy() {
    this.endSub$.complete();
  }
}
